<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs ">
                        <h3>
                            <img src="static/images/icones/refund.png" style="height: 50px">
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">                                          
                        <div class="col-xl-12 menu">
                            <div class="row">
                                <div v-if="$root.user.tipo == 'admin' || ($root.config['menu'][$root.user.tipo].alteracaoOrcamentariaTDC)" class="col-xl-6 col-xs-12" style="">
                                    
                                    <a style="height: 100%;" class="button block-mobile small" v-on:click="setTab('transferencia-despesa-corrente')" v-bind:class="{'transparent': tab != 'transferencia-despesa-corrente', 'color-primary': tab == 'transferencia-despesa-corrente'}">
                                        <i class="las la-circle"></i>
                                        Transferência em Despesa Corrente
                                    </a>
                                </div>                    
                                <div v-if="$root.user.tipo == 'admin' || ($root.config['menu'][$root.user.tipo].alteracaoOrcamentariaSDC)" class="col-xl-6 col-xs-12" style="">

                                    <a style="height: 100%;" class="button block-mobile small" v-on:click="setTab('suplementacao-despesa-corrente')" v-bind:class="{'transparent': tab != 'suplementacao-despesa-corrente', 'color-primary': tab == 'suplementacao-despesa-corrente'}">
                                        <i class="las la-circle"></i>
                                        Suplementação em Despesa Corrente
                                    </a>
                                </div>                    
                                <div v-if="$root.user.tipo == 'admin' || ($root.config['menu'][$root.user.tipo].alteracaoOrcamentariaTPE)" class="col-xl-6 col-xs-12" style="">

                                    <a style="height: 100%;" class="button block-mobile small" v-on:click="setTab('transferencia-planejamento-estrategico')" v-bind:class="{'transparent': tab != 'transferencia-planejamento-estrategico', 'color-primary': tab == 'transferencia-planejamento-estrategico'}">
                                        <i class="las la-circle"></i>
                                        Transferência em Planejamento Estratégico
                                    </a>                      
                                </div>                    
                                <div v-if="$root.user.tipo == 'admin' || ($root.config['menu'][$root.user.tipo].alteracaoOrcamentariaTVO)" class="col-xl-6 col-xs-12" style="">
                                    <a style="height: 100%;" class="button block-mobile small" v-on:click="setTab('transferencia-valor-original')" v-bind:class="{'transparent': tab != 'transferencia-pe-dc', 'color-primary': tab == 'transferencia-valor-original'}">
                                        <i class="las la-circle"></i>
                                        Transferência de valor original
                                    </a>
                                </div>
                                <div v-if="$root.user.tipo == 'admin' || ($root.config['menu'][$root.user.tipo].alteracaoOrcamentariaTPEDC)" class="col-xl-6 col-xs-12" style="">

                                    <a style="height: 100%;" class="button block-mobile small" v-on:click="setTab('transferencia-pe-dc')" v-bind:class="{'transparent': tab != 'transferencia-pe-dc', 'color-primary': tab == 'transferencia-pe-dc'}">
                                        <i class="las la-circle"></i>
                                        Transferência entre Planejamento Estratégico e Despesa Corrente
                                    </a>

                                </div>       
                                <div v-if="$root.user.tipo == 'admin' || ($root.config['menu'][$root.user.tipo].alteracaoOrcamentariaSCLPE)" class="col-xl-6 col-xs-12" style="">
                                    <a style="height: 100%;" class="button block-mobile small" v-on:click="setTab('suplementacao-corte-liberacao-pe')" v-bind:class="{'transparent': tab != 'transferencia-pe-dc', 'color-primary': tab == 'suplementacao-corte-liberacao-pe'}">
                                        <i class="las la-circle"></i>
                                        Suplementação / Corte / Liberação em Planejamento Estratégico
                                    </a>
                                </div>
                            </div>                             
                        </div>                    
                                
                        <div class="col-xl-12 scroll-to"></div>

                        <div class="col-xl-12 margin-top-30" v-show="tab == 'transferencia-despesa-corrente'">
                            <hr>
                            <form type="post" v-on:submit.prevent="submit('formTransferenciaDC')">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-20">
                                        <h3 v-on:click="limparForm('formTransferenciaDC')">
                                            <i class="las la-exchange-alt"></i>
                                            Transferência em Despesa Corrente
                                        </h3>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Origem
                                        </span>
                                    </div>                                

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Centro de custo</h5>
                                            <select class="with-border" v-model="formTransferenciaDC.centroCustoOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + index + '-' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formTransferenciaDC.mesOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'data-referencia-origem' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>
                                        </div>
                                    </div>           

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Conta contábil</h5>
                                            <select class="with-border" v-model="formTransferenciaDC.contaContabilOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataTransferenciaDC.contaContabilOrigem" :key="'conta-contabil' + index + '-' + item.CD_CONTA_CONTABIL" :value="item.CD_CONTA_CONTABIL">{{item.DS_CONTA_CONTABIL}}</option>
                                            </select>                                           
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Destino
                                        </span>
                                    </div>                                                                 

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Centro de custo</h5>
                                            <select class="with-border" v-model="formTransferenciaDC.centroCustoDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + index + '-' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                            </select>
                                        </div>
                                    </div>         

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formTransferenciaDC.mesDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'data-referencia-destino' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Conta contábil</h5>
                                            <select class="with-border" v-model="formTransferenciaDC.contaContabilDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataTransferenciaDC.contaContabilDestino" :key="'conta-contabil' + index + '-' + item.CD_CONTA_CONTABIL" :value="item.CD_CONTA_CONTABIL">{{item.DS_CONTA_CONTABIL}}</option>
                                            </select>   
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Informações
                                        </span>
                                    </div>  


                                    <div class="col-xl-2 col-md-3 col-lg-2 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Valor (R$)</h5>
                                            <money type="tel" v-model="formTransferenciaDC.valor" v-bind="$root.config.money" class=" with-border"></money>
                                            
                                            <!-- <input type="text" placeholder="..." class="with-border" v-model="formTransferenciaDC.valor"> -->
                                        </div>
                                    </div>  

                                    <div class="col-xl-6 col-md-6 col-lg-10 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Observação</h5>
                                            <input type="text" placeholder="..." class="with-border" v-model="formTransferenciaDC.observacoes">
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-20 margin-top-10">
                                        <button type="submit" class="button green block-mobile">
                                            <i class="las la-save"></i>
                                            Salvar movimentação
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>  



                        <div class="col-xl-12 margin-top-30" v-show="tab == 'suplementacao-despesa-corrente'">
                            <hr>
                            <form type="post" v-on:submit.prevent="submit('formSuplementacaoDC')">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-25 margin-top-20">
                                        <h3>
                                            <i class="las la-plus-circle"></i>
                                            Suplementação em Despesa Corrente
                                        </h3>
                                    </div>

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Centro de custo</h5>
                                            <select class="with-border" v-model="formSuplementacaoDC.centroCusto">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + index + '-' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formSuplementacaoDC.mes">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'mes-suplementacao-dc' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>  
                                        </div>
                                    </div>

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Conta contábil</h5>
                                            <select class="with-border" v-model="formSuplementacaoDC.contaContabil">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataSuplementacaoDC.contaContabil" :key="'conta-contabil' + index + '-' + item.CD_CONTA_CONTABIL" :value="item.CD_CONTA_CONTABIL">{{item.DS_CONTA_CONTABIL}}</option>
                                            </select>   
                                        </div>
                                    </div>

                                    <div class="col-xl-2 col-md-3 col-lg-2 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Valor (R$)</h5>
                                            <money type="tel" v-model="formSuplementacaoDC.valor" v-bind="$root.config.money" class=" with-border"></money>
                                        </div>
                                    </div>  

                                    <div class="col-xl-6 col-md-6 col-lg-10 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Observação</h5>
                                            <input type="text" placeholder="..." class="with-border" v-model="formSuplementacaoDC.observacoes">
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-20">
                                        <button type="submit" class="button green block-mobile">
                                            <i class="las la-save"></i>
                                            Salvar movimentação
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>  



                        <div class="col-xl-12 margin-top-30" v-show="tab == 'transferencia-planejamento-estrategico'">
                            <hr>
                            <form type="post" v-on:submit.prevent="submit('formTransferenciaPE')">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-20">
                                        <h3>
                                            <i class="las la-exchange-alt"></i>
                                            Transferência em Planejamento Estratégico
                                        </h3>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Origem
                                        </span>
                                    </div>                                    

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Projeto de origem</h5>
                                            <select class="with-border" v-model="formTransferenciaPE.acaoOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in projetos.itens" :key="'projeto-item-' + index + '-' + item.NR_SEQUENCIA" :value="item.NR_SEQUENCIA">{{item.NM_ETAPA}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formTransferenciaPE.mesOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'mesorigem-transferencia-pe' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>  
                                        </div>
                                    </div>                                    

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Destino
                                        </span>
                                    </div>                                    

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Projeto de destino</h5>
                                            <select class="with-border" v-model="formTransferenciaPE.acaoDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in projetos.itens" :key="'projeto-item-' + index + '-' + item.NR_SEQUENCIA" :value="item.NR_SEQUENCIA">{{item.NM_ETAPA}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formTransferenciaPE.mesDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'mesdestino-transferencia-pe' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>  
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Informações
                                        </span>
                                    </div>  


                                    <div class="col-xl-2 col-md-3 col-lg-2 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Valor (R$)</h5>
                                            <money type="tel" v-model="formTransferenciaPE.valor" v-bind="$root.config.money" class=" with-border"></money>
                                        </div>
                                    </div>  

                                    <div class="col-xl-6 col-md-6 col-lg-10 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Observação</h5>
                                            <input type="text" placeholder="..." class="with-border" v-model="formTransferenciaPE.observacoes">
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-20 margin-top-10">
                                        <button type="submit" class="button green block-mobile">
                                            <i class="las la-save"></i>
                                            Salvar movimentação
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>  


                        <div class="col-xl-12 margin-top-30" v-show="tab == 'transferencia-valor-original'">
                            <hr>
                            <form type="post" v-on:submit.prevent="submit('formTransferenciaValorOriginal')">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-20">
                                        <h3 v-on:click="limparForm('formTransferenciaValorOriginal')">
                                            <i class="las la-exchange-alt"></i>
                                            Transferência de valor original
                                        </h3>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Origem
                                        </span>
                                    </div>                                

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Centro de custo</h5>
                                            <select class="with-border" v-model="formTransferenciaValorOriginal.centroCustoOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + index + '-' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formTransferenciaValorOriginal.mesOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'data-referencia-origem' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Conta contábil</h5>
                                            <select class="with-border" v-model="formTransferenciaValorOriginal.contaContabilOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataTransferenciaValorOriginal.contaContabilOrigem" :key="'conta-contabil' + index + '-' + item.CD_CONTA_CONTABIL" :value="item.CD_CONTA_CONTABIL">{{item.DS_CONTA_CONTABIL}}</option>
                                            </select>                                           
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Destino
                                        </span>
                                    </div>                                                                 

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Centro de custo</h5>
                                            <select class="with-border" v-model="formTransferenciaValorOriginal.centroCustoDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + index + '-' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                            </select>
                                        </div>
                                    </div>         

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formTransferenciaValorOriginal.mesDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'data-referencia-destino' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Conta contábil</h5>
                                            <select class="with-border" v-model="formTransferenciaValorOriginal.contaContabilDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataTransferenciaValorOriginal.contaContabilDestino" :key="'conta-contabil' + index + '-' + item.CD_CONTA_CONTABIL" :value="item.CD_CONTA_CONTABIL">{{item.DS_CONTA_CONTABIL}}</option>
                                            </select>   
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Informações
                                        </span>
                                    </div>  


                                    <div class="col-xl-2 col-md-3 col-lg-2 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Valor (R$)</h5>
                                            <money type="tel" v-model="formTransferenciaValorOriginal.valor" v-bind="$root.config.money" class=" with-border"></money>
                                        </div>
                                    </div>  

                                    <div class="col-xl-6 col-md-6 col-lg-10 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Observação</h5>
                                            <input type="text" placeholder="..." class="with-border" v-model="formTransferenciaValorOriginal.observacoes">
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-20 margin-top-10">
                                        <button type="submit" class="button green block-mobile">
                                            <i class="las la-save"></i>
                                            Salvar movimentação
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>  

                        <div class="col-xl-12 margin-top-30" v-show="tab == 'transferencia-pe-dc'">
                            <hr>
                            <form type="post" v-on:submit.prevent="submit('formTransferenciaPEDC')">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-20">
                                        <h3>
                                            <i class="las la-exchange-alt"></i>
                                            Transferência entre D.C e P.E
                                        </h3>
                                    </div>


                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Origem
                                        </span>
                                    </div>                                    
                                   
                                    <div class="col-xl-3 col-md-4 col-lg-3 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Tipo</h5>
                                            <select class="with-border"  v-model="formTransferenciaPEDC.tipoOrigem" name="tipoOrigem">   
                                                <option value="dc" >Despesa Corrente</option>
                                                <option value="pe">Planejamento Estratégico</option>
                                            </select>    
                                        </div>
                                    </div>       

                                    <div v-if="formTransferenciaPEDC.tipoOrigem == 'pe'" class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Ação de P.E</h5>
                                            <select class="with-border" v-model="formTransferenciaPEDC.acaoOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in projetos.itens" :key="'projeto-item-' + index + '-' + item.NR_SEQUENCIA" :value="item.NR_SEQUENCIA">{{item.NM_ETAPA}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="formTransferenciaPEDC.tipoOrigem == 'dc'" class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Centro de custo</h5>
                                            <select class="with-border" v-model="formTransferenciaPEDC.centroCustoOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + index + '-' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formTransferenciaPEDC.mesOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'data-referencia-origem' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="formTransferenciaPEDC.tipoOrigem == 'dc'" class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Conta contábil</h5>
                                            <select class="with-border" v-model="formTransferenciaPEDC.contaContabilOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataTransferenciaPEDC.contaContabilOrigem" :key="'conta-contabil' + index + '-' + item.CD_CONTA_CONTABIL" :value="item.CD_CONTA_CONTABIL">{{item.DS_CONTA_CONTABIL}}</option>
                                            </select>
                                        </div>
                                    </div>
                           

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Destino
                                        </span>
                                    </div>        

                                    <div class="col-xl-3 col-md-4 col-lg-3 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Tipo</h5>
                                            <select class="with-border"  v-model="formTransferenciaPEDC.tipoDestino" name="tipoDestino">   
                                                <option value="dc">Despesa Corrente</option>
                                                <option value="pe">Planejamento Estratégico</option>
                                            </select>    
                                        </div>
                                    </div>                                                                

                                    <div v-if="formTransferenciaPEDC.tipoDestino == 'pe'" class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Ação de P.E</h5>
                                            <select class="with-border" v-model="formTransferenciaPEDC.acaoDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in projetos.itens" :key="'projeto-item-' + index + '-' + item.NR_SEQUENCIA" :value="item.NR_SEQUENCIA">{{item.NM_ETAPA}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="formTransferenciaPEDC.tipoDestino == 'dc'" class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Centro de custo</h5>
                                            <select class="with-border" v-model="formTransferenciaPEDC.centroCustoDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + index + '-' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formTransferenciaPEDC.mesDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'data-referencia-destino' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="formTransferenciaPEDC.tipoDestino == 'dc'" class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Conta contábil</h5>
                                            <select class="with-border" v-model="formTransferenciaPEDC.contaContabilDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataTransferenciaPEDC.contaContabilDestino" :key="'conta-contabil' + index + '-' + item.CD_CONTA_CONTABIL" :value="item.CD_CONTA_CONTABIL">{{item.DS_CONTA_CONTABIL}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Informações
                                        </span>
                                    </div>  

                                    <div class="col-xl-2 col-md-3 col-lg-2 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Valor (R$)</h5>
                                            <money type="tel" v-model="formTransferenciaPEDC.valor" v-bind="$root.config.money" class=" with-border"></money>
                                        </div>
                                    </div>  

                                    <div class="col-xl-6 col-md-6 col-lg-10 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Observação</h5>
                                            <input type="text" placeholder="..." class="with-border" v-model="formTransferenciaPEDC.observacoes">
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-20 margin-top-10">
                                        <button type="submit" class="button green block-mobile">
                                            <i class="las la-save"></i>
                                            Salvar movimentação
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>  

                        <div class="col-xl-12 margin-top-30" v-show="tab == 'suplementacao-corte-liberacao-pe'">
                            <hr>
                            <form type="post" v-on:submit.prevent="submit('formSuplementacaoCorteLiberacaoPe')">
                                <div class="row">
                                    <div class="col-xl-12 margin-bottom-15 margin-top-20">
                                        <h3>
                                            <i class="las la-exchange-alt"></i>
                                            Suplementação / Corte / Liberação em Planejamento Estratégico
                                        </h3>
                                    </div>

                                    <div class="col-xl-3 col-md-4 col-lg-3 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Tipo da movimentação</h5>
                                            <select class="with-border"  v-model="formSuplementacaoCorteLiberacaoPe.tipoMovimentacao" name="tipoMovimentacao">   
                                                <option value="" selected>Selecione..</option>
                                                <option value="1">Corte</option>
                                                <option value="2">Suplementação</option>
                                                <option value="3">Liberação</option>
                                            </select>    
                                        </div>
                                    </div>        

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Origem
                                        </span>
                                    </div>                                    

                                    <div class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Projeto de origem</h5>
                                            <select class="with-border" v-model="formSuplementacaoCorteLiberacaoPe.acaoOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in projetos.itens" :key="'projeto-item-' + index + '-' + item.NR_SEQUENCIA" :value="item.NR_SEQUENCIA">{{item.NM_ETAPA}}</option>
                                            </select>
                                        </div>
                                    </div>    

                                    <div class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formSuplementacaoCorteLiberacaoPe.mesOrigem">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'data-referencia-origem' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>
                                        </div>
                                    </div>                                                                  

<!--                                     <div v-if="formSuplementacaoCorteLiberacaoPe.tipoMovimentacao != '2'" class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Destino
                                        </span>
                                    </div>                                    

                                    <div v-if="formSuplementacaoCorteLiberacaoPe.tipoMovimentacao != '2'" class="col-xl-4 col-md-6 col-lg-4 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Projeto de destino</h5>
                                            <select class="with-border" v-model="formSuplementacaoCorteLiberacaoPe.acaoDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in projetos.itens" :key="'projeto-item-' + index + '-' + item.NR_SEQUENCIA" :value="item.NR_SEQUENCIA">{{item.NM_ETAPA}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="formSuplementacaoCorteLiberacaoPe.tipoMovimentacao != '2'" class="col-xl-3 col-md-6 col-lg-3 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Mês de referência</h5>
                                            <select class="with-border" v-model="formSuplementacaoCorteLiberacaoPe.mesDestino">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in dataReferencia.itens" :key="'data-referencia-destino' + index + '-' + item.DT_REFERENCIA" :value="item.DT_REFERENCIA">{{item.DS}}</option>
                                            </select>
                                        </div>
                                    </div>  -->                                       

                                    <div class="col-xl-12 margin-bottom-15">
                                        <span class="dashboard-status-button gray">
                                            Informações
                                        </span>
                                    </div>  

                                    <div class="col-xl-2 col-md-3 col-lg-2 col-xs-6">
                                        <div class="submit-field">
                                            <h5>Valor (R$)</h5>
                                            <money type="tel" v-model="formSuplementacaoCorteLiberacaoPe.valor" v-bind="$root.config.money" class=" with-border"></money>
                                        </div>
                                    </div>  

                                    <div class="col-xl-6 col-md-6 col-lg-10 col-xs-12">
                                        <div class="submit-field">
                                            <h5>Observação</h5>
                                            <input type="text" placeholder="..." class="with-border" v-model="formSuplementacaoCorteLiberacaoPe.observacoes">
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-20 margin-top-10">
                                        <button type="submit" class="button green block-mobile">
                                            <i class="las la-save"></i>
                                            Salvar movimentação
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>  

                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'FinanceiroMovimentacoes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "tab":                  "",
            "projetos":          {
                "itens":            [],
                "total":            0
            },  
            "centroCusto":          {
                "itens":            [],
                "total":            0
            },  
            "contaContabil":          {
                "itens":            [],
                "total":            0
            },  
            "dataReferencia":       {
                "itens":            [],
                "total":            0
            },                                      
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "dataTransferenciaValorOriginal": {
                "contaContabilOrigem":  [],
                "contaContabilDestino": [],
            },
            "dataTransferenciaDC": {
                "contaContabilOrigem":  [],
                "contaContabilDestino": [],
            },
            "dataTransferenciaPEDC": {
                "contaContabilOrigem":  [],
                "contaContabilDestino": [],
            },            
            "dataSuplementacaoDC": {
                "contaContabil":    [],
            },            
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "",
                "contaContabil":    "",
            },
            "formTransferenciaValorOriginal": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "transferencia-valor-original",
                "contaContabilOrigem":      "",
                "centroCustoOrigem":        "",
                "contaContabilDestino":     "",
                "centroCustoDestino":       "",  
                "observacoes":              "",
                "mesOrigem":                "",
                "mesDestino":                "",
                "valor":                    "",        
            },    
            "formSuplementacaoDC": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "suplementacao-despesa-corrente",
                "mes":              "",
                "valor":            "",
                "observacoes":      "",
                "contaContabil":    "",
                "centroCusto":      "",
            },    
            "formTransferenciaPE": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "transferencia-planejamento-estrategico",
                "acaoOrigem":       "",
                "acaoDestino":      "",
                "mesOrigem":        "",
                "mesDestino":       "",
                "valor":            "",
                "observacoes":      "",
            },
            "formSuplementacaoCorteLiberacaoPe": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "suplementacao-corte-liberacao-pe",
                "tipoMovimentacao": "",
                "acaoOrigem":       "",
                "acaoDestino":      "",
                "mesOrigem":        "",
                "mesDestino":       "",
                "valor":            "",
                "observacoes":      "",
            },            
            "formTransferenciaPEDC": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "transferencia-pe-dc",
                "tipoOrigem":       "dc",
                "centroCustoOrigem":      "",
                "contaContabilOrigem":    "",
                "centroCustoDestino":      "",
                "contaContabilDestino":    "",
                "mesOrigem":        "",
                "mesDestino":       "",
                "acaoOrigem":       "",
                "acaoDestino":      "",
                "tipoDestino":      "pe",
                "valor":            "",
                "observacoes":      "",
            },              
            "formTransferenciaDC": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "transferencia-despesa-corrente",
                "contaContabilOrigem":      "",
                "centroCustoOrigem":        "",
                "contaContabilDestino":     "",
                "centroCustoDestino":       "",  
                "observacoes":              "",
                "mesOrigem":                "",
                "mesDestino":                "",
                "valor":                    "",              
            }              
        }
    },
    watch: {
        "formTransferenciaPEDC.centroCustoOrigem": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaPEDC.centroCustoOrigem > ", val);
                if (val && self.formTransferenciaPEDC.mesOrigem) {
                    self.getContaContabil(val, self.formTransferenciaPEDC.mesOrigem).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaPEDC.contaContabilOrigem = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }            
        }, 
        "formTransferenciaPEDC.centroCustoDestino": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaPEDC.centroCustoDestino > ", val);
                if (val && self.formTransferenciaPEDC.mesDestino) {
                    self.getContaContabil(val, self.formTransferenciaPEDC.mesDestino).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaPEDC.contaContabilDestino = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }
        },     
        "formTransferenciaPEDC.mesOrigem": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaPEDC.mesOrigem > ", val);
                if (val && self.formTransferenciaPEDC.centroCustoOrigem) {
                    self.getContaContabil(self.formTransferenciaPEDC.centroCustoOrigem, val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaPEDC.contaContabilOrigem = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }            
        }, 
        "formTransferenciaPEDC.mesDestino": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaPEDC.mesDestino > ", val);
                if (val && self.formTransferenciaPEDC.centroCustoDestino) {
                    self.getContaContabil(self.formTransferenciaPEDC.centroCustoDestino, val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaPEDC.contaContabilDestino = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }
        },     

        "formSuplementacaoDC.centroCusto": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formSuplementacaoDC.centroCusto > ", val);
                if (val && self.formSuplementacaoDC.mes) {
                    self.getContaContabil(val, self.formSuplementacaoDC.mes).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataSuplementacaoDC.contaContabil = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }            
        }, 
        "formSuplementacaoDC.mes": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formSuplementacaoDC.mes > ", val);
                if (val && self.formSuplementacaoDC.centroCusto) {
                    self.getContaContabil(self.formSuplementacaoDC.centroCusto, val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataSuplementacaoDC.contaContabil = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }            
        },         
        "formTransferenciaValorOriginal.centroCustoOrigem": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaValorOriginal.centroCustoOrigem > ", val);
                if (val && self.formTransferenciaValorOriginal.mesOrigem) {
                    self.getContaContabil(val, self.formTransferenciaValorOriginal.mesOrigem).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaValorOriginal.contaContabilOrigem = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }            
        }, 
        "formTransferenciaValorOriginal.centroCustoDestino": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaValorOriginal.centroCustoDestino > ", val);
                if (val && self.formTransferenciaValorOriginal.mesDestino) {
                    self.getContaContabil(val, self.formTransferenciaValorOriginal.mesDestino).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaValorOriginal.contaContabilDestino = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }
        },   
        "formTransferenciaValorOriginal.mesOrigem": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaValorOriginal.mesOrigem > ", val);
                if (val && self.formTransferenciaValorOriginal.centroCustoOrigem) {
                    self.getContaContabil(self.formTransferenciaValorOriginal.centroCustoOrigem, val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaValorOriginal.contaContabilOrigem = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }            
        }, 
        "formTransferenciaValorOriginal.mesDestino": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaValorOriginal.mesDestino > ", val);
                if (val && self.formTransferenciaValorOriginal.centroCustoDestino) {
                    self.getContaContabil(self.formTransferenciaValorOriginal.centroCustoDestino, val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaValorOriginal.contaContabilDestino = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }
        },           
        "formTransferenciaDC.centroCustoOrigem": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaDC.centroCustoOrigem > ", val);
                if (val && self.formTransferenciaDC.mesOrigem) {
                    self.getContaContabil(val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaDC.contaContabilOrigem = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }            
        }, 
        "formTransferenciaDC.centroCustoDestino": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaDC.centroCustoDestino > ", val);
                if (val && self.formTransferenciaDC.mesDestino) {
                    self.getContaContabil(val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaDC.contaContabilDestino = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }
        },   
        "formTransferenciaDC.mesOrigem": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaDC.centroCustoOrigem > ", val);
                if (val && self.formTransferenciaDC.centroCustoOrigem) {
                    self.getContaContabil(self.formTransferenciaDC.centroCustoOrigem, val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaDC.contaContabilOrigem = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }            
        }, 
        "formTransferenciaDC.mesDestino": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaDC.centroCustoDestino > ", val);
                if (val && self.formTransferenciaDC.centroCustoDestino) {
                    self.getContaContabil(self.formTransferenciaDC.centroCustoDestino, val).then(function(result) {
                        console.log("setou resultados", result.itens);
                        self.dataTransferenciaDC.contaContabilDestino = result.itens;
                        self.$forceUpdate();
                    }).catch(function(error) {
                        console.log("error", error);
                    });
                }
            }
        },  
        "formTransferenciaPEDC.tipoOrigem": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaPEDC.tipoOrigem > ", val);
                if (val == "dc" && self.formTransferenciaPEDC.tipoDestino != "pe") {
                    self.formTransferenciaPEDC.tipoDestino = "pe";
                    self.$forceUpdate();
                } else if (val == "pe" && self.formTransferenciaPEDC.tipoDestino != "dc") {
                    self.formTransferenciaPEDC.tipoDestino = "dc";
                    self.$forceUpdate();
                }
            }
        },
        "formTransferenciaPEDC.tipoDestino": {
            deep: true,
            handler: function(val) {
                var self = this;
                console.log("watch > formTransferenciaPEDC.tipoDestino > ", val);
               
                if (val == "dc" && self.formTransferenciaPEDC.tipoOrigem != "pe") {
                    self.formTransferenciaPEDC.tipoOrigem = "pe";
                    self.$forceUpdate();
                } else if (val == "pe" && self.formTransferenciaPEDC.tipoOrigem != "dc") {
                    self.formTransferenciaPEDC.tipoOrigem = "dc";
                    self.$forceUpdate();
                }               
            }
        },        
    },    
    methods: {
        limparForm: function(form) {
            var self = this;

            (Object.keys(self[form])).forEach(function(item) {
                if (item != "tipo") {
                    self[form][item] = "";
                }
            });
            self.$forceUpdate();
        },
        submit: function(form) {
            var self            = this;
            console.log("submit()", self[form]);
            loading.show();

            self[form]["_cod"]      = self.$root.user.cod;
            self[form]["_token"]    = self.$root.user.token;
                
            axios.post("api/financeiro-movimentacoes.php", self[form])
            .then(response => {
                
                console.log("submit() response", response)
                loading.hide();

                self.limparForm(form);

                alert(response.data.message);
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },          
        getProjetos: function() {
            var self        = this;
            console.log("getProjetos()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "projetos"
                    }
                };

                axios.get("api/financeiro.php", form)
                .then(response => {
                    
                    console.log("getProjetos() response", response);
                    self.projetos   = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getProjetos() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },  
        getCentroCusto: function() {
            var self        = this;
            console.log("getCentroCusto()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "centro-de-custo"
                    }
                };

                axios.get("api/financeiro.php", form)
                .then(response => {
                    
                    console.log("getCentroCusto() response", response);
                    self.centroCusto   = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCentroCusto() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getDataReferencia: function() {
            var self        = this;
            console.log("getDataReferencia()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "data-referencia"
                    }
                };

                axios.get("api/financeiro.php", form)
                .then(response => {
                    
                    console.log("getDataReferencia() response", response);
                    self.dataReferencia  = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getDataReferencia() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },          
        getContaContabil: function(id, mes) {
            var self        = this;
            console.log("getContaContabil()", id);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "CD_CENTRO_CUSTO": id,
                        "mes":          (mes ? mes : null),
                        "tipo":         "conta-contabil"
                    }
                };

                axios.get("api/financeiro.php", form)
                .then(response => {
                    
                    console.log("getContaContabil() response", response);
                    // self.contaContabil   = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getContaContabil() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },                  
        setTab: function(tab, scroll = true) {
            var self        = this;
            console.log("setTab()", tab);
            if (self.tab == tab) return false;

            // self.$root.tmp.configuracoes.tab = tab;
            self.$root.$forceUpdate();

            self.tab        = tab;
            loading.show();
            setTimeout(function() {
                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });  
                loading.hide();
            }, 100);
            // self.getItens(scroll);
        },            
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.data.pesquisa != self.form.pesquisa) {
                    self.form.page  = 1;
                }

                axios.get("api/usuarios.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    self.$root.scrollTop();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }      
    },
    created: function() {
        var self = this;
    },
    mounted: function() {
        var self = this;
        loading.hide();
        this.setTab("transferencia-despesa-corrente");


        Promise.all([
            // self.getContaContabil(),
            self.getDataReferencia(),
            self.getCentroCusto(),
            self.getProjetos(),
        ]).then(function() {
            
        }).catch(function(error) {
            // loading.hide();
            
            
        });           
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    hr {
        opacity: 0.2;
    }
    h3 i {
        color: var(--theme-color-primary);
    }   
    .button.block-mobile.small {
        border: 2px solid var(--theme-color-primary);
    }
    .trumbowyg-editor {
        height: 500px !important;
    }
    textarea[name="politicasPrivacidade"] {
        display: none !important;
    }
    textarea[name="termosUso"] {
        display: none !important;
    }    
    .menu .button i {
        margin-right: 10px;
    }

    .menu .button {
        margin-bottom: 0px;
        margin-right: 3px;
        width: 100%;
        

        display: flex;
        vertical-align: middle;
        flex-direction: row;
        align-items: center;        
    }

    .menu .col-xs-12 {
        margin-bottom: 5px;        
    }

    @media only screen and (max-width: 736px) { 
        .menu .col-xs-12:not(:last-child) .button {
            border-bottom: 0px !important;
        }
        .menu .col-xs-12 {
            margin-bottom: 0px !important;        
        }        
        .menu .button {
            margin-right: 0px !important;
            border-top-right-radius: 0px;
            border-top-left-radius: 0px;
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 0px;
        }
        .menu .col-xs-12:first-child .button {
            border-top-right-radius: 6px !important;
            border-top-left-radius: 6px !important;
        }        
        .menu .col-xs-12:last-child .button {
            border-bottom-right-radius: 6px !important;
            border-bottom-left-radius: 6px !important;
        }                
    }
</style>



// WEBPACK FOOTER //
// src/components/FinanceiroMovimentacoes.vue